import React, { useEffect } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

function HiringReqOptions() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeDataForAccess = useSelector(
    (state) => state.employee?.employeeData
  );

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeDataForAccess !== null &&
      employeeDataForAccess?.admin?.hiringReq === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeDataForAccess]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const optionsArr = [
    {
      title: "Make A New Hiring Request",
      link: "/admin/new/request/hiring",
    },
    {
      title: "View All Hiring Request",
      link: "/admin/all/request/hiring",
    },
    {
      title: "View All Shortlisted Applicants for Interview",
      link: "/admin/hiring/req/shortlisted/applicants",
    }
  ];

  return (
    <div className="w-full flex justify-center items-center">
      <div className="w-[90vw] py-5">
        <h1 className="text-[30px] font-medium text-left w-full">
          Hiring Request & Interviews
        </h1>
        <div className="w-full mt-5">
          <div className="rounded-[10px] border">
            {optionsArr.map((opt, i) => (
              <Link to={opt.link} key={i}>
                <section
                  className={`p-3 flex justify-between items-center hover:bg-slate-50 ${
                    i === optionsArr.length - 1 ? "" : "border-b-[1px]"
                  }`}
                >
                  <p className="text-slate-700 font-normal text-[17px]">
                    {opt.title}
                  </p>
                  <MdArrowForwardIos className="text-slate-500" />
                </section>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HiringReqOptions;
